import React, { useState } from 'react';
import { Box, Button, Chip, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { useUsersAdminTable } from '../hooks/useUsersAdminTable';
import { getProfesionLabel, getRoleLabel } from '../model/userConstants';
import { usePermissions } from '../../../shared/auth/PermissionsContext';
import UserPermissionsDialog from './UserPermissionsDialog';

const ROLE_CHIP_COLORS = {
  SUPERADMIN: 'error',
  ADMIN: 'primary',
  SANITARIO: 'default',
};

export default function AdminUsersTable() {
  const {
    rows, filterId, setFilterId, filterNombre, setFilterNombre, filterProfesional, setFilterProfesional, sortDate, setSortDate, toggleUserActive, fetchUsers,
  } = useUsersAdminTable();
  const { hasPermission } = usePermissions();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedRow, setSelectedRow] = useState(null);
  const [permissionsUser, setPermissionsUser] = useState(null);

  const canToggleActive = hasPermission('users:activate');
  const canManagePermissions = hasPermission('users:manage_permissions');

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" component="h2" gutterBottom color="#0D6AEE">Lista de Usuarios</Typography>
        <Box display="flex" gap={2}>
          {canManagePermissions ? (
            <Button variant="outlined" disabled={!selectedRow} onClick={() => selectedRow && setPermissionsUser(selectedRow)}>
              Permisos
            </Button>
          ) : null}
          {canToggleActive ? (
            <Button variant="contained" disabled={!selectedRow} onClick={() => selectedRow && toggleUserActive(selectedRow)}>
              {selectedRow && selectedRow.active ? 'Dar de Baja' : 'Activar'}
            </Button>
          ) : null}
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <TextField name="id" label="Filtrar por ID" value={filterId} onChange={(e) => setFilterId(e.target.value)} style={{ marginRight: 16 }} />
        <TextField name="nombre" label="Filtrar por Nombre" value={filterNombre} onChange={(e) => setFilterNombre(e.target.value)} style={{ marginRight: 16 }} />
        <TextField name="profesional" label="Filtrar por Profesional" value={filterProfesional} onChange={(e) => setFilterProfesional(e.target.value)} style={{ marginRight: 16 }} />
        <Button variant="contained" onClick={() => setSortDate(sortDate === 'asc' ? 'desc' : 'asc')} style={{ marginRight: 16 }}>
          Ordenar por fecha {sortDate === 'asc' ? '⬆️' : '⬇️'}
        </Button>
        <Button variant="contained" onClick={() => { setFilterId(''); setFilterNombre(''); setFilterProfesional(''); setSortDate(null); }}>
          Resetear Filtros
        </Button>
      </Box>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 400 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>id</TableCell>
                <TableCell>usuario</TableCell>
                <TableCell>nombre</TableCell>
                <TableCell>email</TableCell>
                <TableCell>profesión</TableCell>
                <TableCell>rol</TableCell>
                <TableCell>estado</TableCell>
                <TableCell align="right">fecha de creación</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length === 0 ? (
                <TableRow><TableCell colSpan={8} align="center">No hay usuarios registrados</TableCell></TableRow>
              ) : rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                <TableRow
                  key={row.id}
                  hover
                  selected={selectedRow?.id === row.id}
                  onClick={() => setSelectedRow(row)}
                  sx={{ cursor: 'pointer', backgroundColor: row.active ? 'white' : 'lightgrey' }}
                >
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.username}</TableCell>
                  <TableCell>{row.nombre}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>{getProfesionLabel(row.profesional)}</TableCell>
                  <TableCell>
                    <Chip size="small" color={ROLE_CHIP_COLORS[row.role] || 'default'} label={getRoleLabel(row.role)} />
                  </TableCell>
                  <TableCell>
                    <Chip size="small" color={row.active ? 'success' : 'default'} label={row.active ? 'Activo' : 'Inactivo'} />
                  </TableCell>
                  <TableCell align="right">{new Date(row.createdAt).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination rowsPerPageOptions={[5, 10, 20]} component="div" count={rows.length} rowsPerPage={rowsPerPage} page={page} onPageChange={(_e, newPage) => setPage(newPage)} onRowsPerPageChange={(e) => { setRowsPerPage(+e.target.value); setPage(0); }} />
      </Paper>
      <UserPermissionsDialog
        user={permissionsUser}
        open={!!permissionsUser}
        onClose={() => setPermissionsUser(null)}
        onSaved={() => { setSelectedRow(null); fetchUsers(); }}
      />
    </>
  );
}
